import { apiClient } from "../config";

async function getProtocolProfile(ProtocolId: string) {
  const res = await apiClient.get(`/admin/protocols/${ProtocolId}`);
  return res.data;
}

export default getProtocolProfile;
